import qs from "qs";
import axios from "axios";
import { getCookie, Auth } from "../../../lib/cookie";

export class RuejaiClubSalePackagesClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/packages`;
  }

  // eslint-disable-next-line class-methods-use-this
  get token() {
    return getCookie(Auth.AccessToken);
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/sales${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  // PROBLEM: now we hard code for prefill with production package data
  // TODO: fix hardcode
  async getProductionPackage(id) {
    const url = `https://baanruejai-api.scasset.com/api/admin/subscriptions/recommend_packages/${id}`;

    const response = axios.get(url, {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    });

    return response;
  }
}
